/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.skip-navigation--link[_ngcontent-%COMP%]{display:block;padding:1em;background:#2c2c2c;border:2px solid #fff;position:absolute;text-decoration:underline;color:#fff;font-family:Lato;white-space:nowrap;left:6px;z-index:10000;top:-80px;opacity:0;transition:opacity .6s ease}.skip-navigation--link[_ngcontent-%COMP%]:focus{top:6px;opacity:1}"];
export { styles as styles };
